import React, {Component} from 'react'
import {Link} from 'react-router-dom';
import Img from 'react-image';
import data from "../photos";

class Home extends Component {

	constructor(props)
	{
		super(props);

		this.state = {
			dossiers: data.dossiers
		};
	}

	shouldComponentUpdate(nextState)
	{
		return nextState !== this.state;
	}

	loadFolder(key, url)
	{
		let that = this;

		fetch(url)
			.then(function (response) {
				return response.json()
			}).then(function (json) {

			let dossiers = that.state.dossiers;
			that.state.dossiers[key].images = json.images;
			that.setState({dossiers: dossiers});
		});
	}

	loadFolders()
	{
		let that = this;

		{Object.keys(this.state.dossiers).map(function(key) {

			that.loadFolder(key, that.state.dossiers[key].url);

		})}
	}

	componentDidMount()
	{

		this.loadFolders();
	}

	render()
	{
		let that = this;

		return (
			<div>
				<div id="titre">
					<div id="logo">
						<div id="logo_bottom" />
						<div id="logo_top" />
					</div>
				</div>

				<div className="page-center">
					<div className="wrap">
						{Object.keys(this.state.dossiers).map(function(key) {

							let dossier = that.state.dossiers[key];
							let i = 0;

							return <Link to={key} className="liste">

								<div className="titre">
									{dossier.nom}
								</div>

								<div className="wrap">
									{dossier.images.map(function (img) {
										i++;
										if(i > 5)
											return;

										return <div className="item">
											<Img
												src={img.thumbs}
												alt=""
												loader={
													<div className="spinner" />
												}
												unloader={
													"Erreur de chargement"
												}
											/>
										</div>
									})}
								</div>
							</Link>
						})}


						<Link to="musiques" className="liste">
							<div className="titre">
								Musiques
							</div>

							<div className="wrap">
								<div className="item">
									<Img
										src="https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/11%20-%20Discours/?r=picture/thumbs/&img=IMG_5198.JPG"
										alt=""
										loader={
											<div className="spinner" />
										}
										unloader={
											"Erreur de chargement"
										}
									/>
								</div>
								<div className="item">
									<Img
										src="https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/11%20-%20Discours/?r=picture/thumbs/&img=IMG_5196.JPG"
										alt=""
										loader={
											<div className="spinner" />
										}
										unloader={
											"Erreur de chargement"
										}
									/>
								</div>
								<div className="item">
									<Img
										src="https://brut.ljos.fr/Mariage/Jonas%20et%20Marine/11%20-%20Discours/?r=picture/thumbs/&img=IMG_5192.JPG"
										alt=""
										loader={
											<div className="spinner" />
										}
										unloader={
											"Erreur de chargement"
										}
									/>
								</div>
							</div>
						</Link>
					</div>
				</div>

				<div id="footer">
					Photos par <a href="http://ljos.fr/contact" target="_blank" rel="noopener noreferer">Ljos Photographie</a>
				</div>
			</div>
		);
	}
}


export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js